import { createAction } from '@reduxjs/toolkit'

export const createAdmin = createAction('roles/createAdmin')
export const updateAdmin = createAction('roles/updateAdmin')
export const deleteAdmin = createAction('roles/deleteAdmin')
export const fetchAllAdmins = createAction('roles/fetchAllAdmins')
export const resetPassword = createAction('roles/resetPassword')
